const Home = () => import('@/views/Home/home')
/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export const PublicModulesRouteMap = {
  PublicModules: 'public-modules',
  PlatformMonitor: 'monitor',
  BillingConfiguration: 'billing-configuration',
  SystemConfiguration: 'system-configuration',
  TransferConfiguration: 'transfer-configuration',
  StorageManagement: 'storage-management',
  EmployeeManagement: 'admin',
  PackManagement: 'pack-management',
  FeedbackManagement: 'feedback-management',
}

const PublicModules = [
  {
    path: '/',
    name: 'monitor',
    title: '平台监控',
    component: Home,
    meta: {
      title: '平台监控',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'monitor:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/',
    name: 'billing-configuration',
    title: '计费配置',
    component: Home,
    meta: {
      title: '计费配置',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'public:charge:config',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/',
    name: 'system-configuration',
    title: '系统配置',
    component: Home,
    meta: {
      title: '系统配置',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'public:system:config',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/',
    name: 'transfer-configuration',
    title: '传输配置',
    component: Home,
    meta: {
      title: '传输配置',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'transfer:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/',
    name: PublicModulesRouteMap.StorageManagement,
    title: '存储管理',
    component: Home,
    meta: {
      title: '存储管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'storage:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '',
    name: 'admin',
    title: '员工管理',
    component: Home,
    meta: {
      title: '员工管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'admin:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '',
    name: 'pack-management',
    title: '包机包项目管理',
    component: Home,
    meta: {
      title: '包机包项目管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'pack:root',
      modules: 'user',
    },
    children: [],
  },
  {
    path: '/',
    name: 'feedback-management',
    title: '反馈管理',
    component: Home,
    meta: {
      title: '反馈管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'feedback:root',
      modules: 'user',
    },
    children: [],
  },
]

export default PublicModules
